// extracted by mini-css-extract-plugin
export default {"grid":"viewer-section_grid__4hbRc"};